export const FIREBASE_CONFIG = {
	apiKey: 'AIzaSyDiKrD81GWoCGGcmrip3BuGEiRXRS05itU',
	authDomain: 'coyote-grill-promo-1.firebaseapp.com',
	databaseURL: 'https://coyote-grill-promo-1.firebaseio.com',
	storageBucket: 'coyote-grill-promo-1.appspot.com',
	messagingSenderId: '263952148100'
};

export const CONTACT_EMAIL = 'contact@coyotegrill.bar';

export const BREAKPOINTS = {
	VERY_SMALL_SCREEN: 550,
	SMALL_DESKTOP: 768,
	MEDIUM_DESKTOP: 992,
	LARGE_DESKTOP: 1200
};
